import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes
} from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { Settings } from 'luxon';
import './App.css';
import NavBar from './components/NavBar';
import Current from './components/Current/Current';
import Forecast from './components/Forecast/Forecast';
import History from './components/History/History';
import Reports from './components/Reports/Reports';

Settings.defaultZoneName = process.env.REACT_APP_DEFAULT_LUXON_ZONE_NAME;

class App extends Component {
  render() {
    const theme = createTheme({ palette: { mode: 'dark' } });

    return (
      <Router>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <div className="App">
              <NavBar />
              <Routes>
                <Route path="/current" element={<Current />} />
                <Route path="/forecast" element={<Forecast />} />
                <Route path="/history" element={<History />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/" element={<Navigate to="/current" replace />} />
              </Routes>
            </div>
          </LocalizationProvider>
        </ThemeProvider>
      </Router>
    );
  }
}

export default App;
